
<template>
  <div class="cores">
    <template>
      <v-card>
        <v-card-title>
          Mulesoft FI Config
          <v-spacer></v-spacer>
          <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-container fluid>
                    <v-row align="center">
              <v-col class="d-flex" cols="2" sm="6">
                <v-select
                  :items="fiVersions"
                  @change="selectFiVersion(fiVersion)"
                  v-model="fiVersion"
                  label="Select Version"
                ></v-select>
              </v-col>
            </v-row>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="filteredFiData"
          :loading="loading"
          :items-per-page="10"
          :search="search"
          class="elevation-2"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.config.coreName }}</td>
            <td>{{ props.item.fiid }}</td>
            <td>{{ props.item.version }}</td>
            <td>

              <v-btn color="info" dark @click="editItem(props)">
                <font-awesome-icon icon="edit" class="pr-1" />Edit
              </v-btn>

            </td>
          </template>

        </v-data-table>
        </v-container>
      </v-card>
    </template>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <template v-slot:activator="{ on }">
        <v-btn @click="newItem()" color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
      </template>
      <v-card>
        <div v-if="this.newItemCheck">
        <v-card-title>
          <span class="headline">New Item</span>
        </v-card-title>
        <v-card-subtitle>
          <center>
            <p class="headline mb-1">
              Please choose a Core Name before filling out
              any additional information
            </p>
          </center>
        </v-card-subtitle>
        </div>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  :items="coreNames"
                  @change="changedCoreValue(coreName)"
                  v-model="coreName"
                  label="Core Name"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.version" label="Version"></v-text-field>

              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="editedItem.fiid"
                  label="FI ID"
                  :disabled="newItemCheck==false"
                  type="number"
                  :rules="['Required']"
                  :persistent-hint="true"
                  :hint="fiIdDescription"
                ></v-text-field>
              </v-col>
              <div v-for="(value, i) in editedItem.fiFileNames" :key="i">
                <v-text-field
                  :persistent-hint="true"
                  :hint="fiFileNameDescription"
                  v-model="editedItem.fiFileNames[i]"
                  :label="'FI File Name - ' +i"
                ></v-text-field>
              </div>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.fiName" label="FI Name"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-switch
                  v-model="editedItem.fixedwidth"
                  :persistent-hint="true"
                  :hint="fixedWidthDescription"
                  label="Fixed Width?"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.delimiter" label="Delimiter"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';
import { Core, Config } from '@/types/filemoverConfig';
import MulesoftFiService from '@/MulesoftFiService';

@Component
export default class MulesoftFiConfig extends Vue {
  /*eslint-disable */
  data() {
    return {
      search: "",
      menu: false,
      dialog: false,
      selected: [],
      newItemCheck: false,
      filteredFiData: [],
      coreName: "",
      fiVersion: "",
      version: "v1",
      formattedItem: {},
      fiVersions: [],
      coreNames: [],
      fixedWidthDescription:
        "If this field is set to true, the delimiter field will not be used",
      fiIdDescription:
        "This field must consist of numbers only (generally 4 digits)",
      fiFileNameDescription: "Example: CustDetail.csv"
    };
  }
  /* eslint-enable */

  emptyItem = {
    fiName: '',
    coreName: '',
    fiid: '',
    fixedwidth: false,
    version: '',
    delimiter: '',
    fiFileNames: {
      accountLoan: '',
      accountShare: '',
      atm: '',
      cif: '',
      transactions: '',
    },
    _comment: '',
  };

  editedItem = this.emptyItem;

  loading = false;

  headers = [
    {
      text: 'Core Name',
      sortable: true,
      align: 'left',
    },
    {
      text: 'FI ID',
      sortable: true,
      align: 'left',
    },
    {
      text: 'Version',
      sortable: true,
      align: 'left',
    },
    {
      text: 'Actions',
      value: 'action',
      sortable: false,
    },
  ];

  newItem() {
    this.newItemCheck = true;
    this.editedItem = this.emptyItem;
  }

  async changedCoreValue(core) {
    this.editedItem.coreName = core;
    this.emptyItem.fiFileNames = await MulesoftFiService.getMulesoftCoreRelationships(
      'v1',
      core,
    );
  }

  close() {
    this.dialog = false;
    setTimeout(() => {
      this.editedItem = Object.assign({}, this.emptyItem);
      this.coreName = '';
    }, 300);
  }

  editItem(fi) {
    this.newItemCheck = false;
    this.dialog = true;
    this.formatItemData(fi.item);
  }


  formatItemData(item) {
    this.formattedItem = {

      fiName: item.config.fiName,
      version: item.version,
      coreName: item.config.coreName,
      fiid: item.fiid,
      fixedwidth: item.config.fixedwidth,
      delimiter: item.config.delimiter,
      fiFileNames: JSON.parse(item.config.fiFileNames),
      // eslint-disable-next-line no-underscore-dangle
      _comment: item.config._comment,
    };
    this.editedItem = this.formattedItem;
    this.coreName = item.config.coreName;
  }

  async save() {
    await MulesoftFiService.addFi(this.editedItem);
    this.loading = false;
    this.close();
  }

  async mounted() {
    this.loading = true;
    this.coreNames = await MulesoftFiService.getAllMulesoftCores();
    this.fiData = await MulesoftFiService.getFiTable();
    this.filterVersions(this.fiData);
    this.loading = false;
  }

  filterVersions(fiData) {
    const versions = fiData.map(data => data.version);
    this.fiVersions = [...new Set(versions)];
  }

  selectFiVersion(fiVersion) {
    this.filteredFiData = this.fiData.filter(fi => fi.version === fiVersion);
  }
}
</script>
